<template>
  <div>
    <b-form-textarea
      v-model="inputText"
      placeholder="Digite sua mensagem aqui"
    ></b-form-textarea>
    <div class="text-center">
      <b-button variant="primary" @click="gerarResposta">Enviar</b-button>
    </div>
    <div v-if="respostaGerada" class="resposta">{{ respostaGerada }}</div>
  </div>
</template>

<script>
// import API from "../services/apiservices";

export default {
  name: "GPT3",
  data() {
    return {
      apiKey: process.env.VUE_APP_GPT3_APIKEY,
      modelEndpoint:
        "https://api.openai.com/v1/engines/davinci-codex/completions",
      inputText: "Quantas letras tem a palavra 'Programador' ?",
      respostaGerada: "",
    };
  },
  methods: {
    gerarResposta() {
      // console.log("gerarResposta.process.env.VUE_APP_GPT3_APIKEY:",process.env.VUE_APP_GPT3_APIKEY);
      // console.log("gerarResposta.apiKey:", this.apiKey);
      // console.log("gerarResposta.process.env.NODE_ENV:", process.env.NODE_ENV);

      const data = {
        prompt: this.inputText,
        max_tokens: 50, // Número máximo de tokens para limitar o tamanho da resposta
        temperature: 0.8, // Controla a aleatoriedade da resposta gerada
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.apiKey}`,
        },
        body: JSON.stringify(data),
      };

      // console.log("gerarResposta.data:", data);
      // console.log("gerarResposta.option:", options);

      // return;

      fetch(this.modelEndpoint, options)
        .then((response) => response.json())
        .then((data) => {
          console.log("data:", data);
          if (data.error) {
            this.$root.toastdanger(data.error.message);
          } else {
            this.respostaGerada = data.choices[0].text; // Extrai o texto da resposta da API
          }
        })
        .catch((error) => {
          const { message } = error;
          console.log("message:", message);
          // console.error(error);
        });
      // API.post(this.modelEndpoint, options)
      //   .then((data) => {
      //     console.log("success:", data);
      //     this.respostaGerada = data.choices[0].text; // Extrai o texto da resposta da API
      //   })
      //   .catch((error) => console.log("error:", error));
    },
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  height: 100px;
  margin-bottom: 10px;
}
.resposta {
  margin-top: 10px;
}
</style>
